import { Navigate, Outlet } from 'react-router-dom';

import { AppRoutesPaths } from './types';
import { Loading } from '@sandtech-hub-monorepo/ui-kit-site';
import { useCognito } from '@sandtech-hub-monorepo/ui-auth-kit';

export const GuardedRoutes: React.FC = () => {
  const { currentUser, loading } = useCognito();

  if (loading) {
    return <Loading />;
  }

  if (!currentUser && !loading) {
    return <Navigate to={AppRoutesPaths.Login} replace={true} />;
  }

  return <Outlet />;
};
